import React from 'react'
import { Box } from '@mui/material'
import { BigLogo } from '../../../../assets/images'

type Props = {
  children: any
}

const LRFLayout = (props: Props) => {
  const { children } = props

  return (
    <div className="flex justify-center h-screen">
      {/* Left side */}
      <Box bgcolor={'secondary.main'} className="w-1/2 hidden md:flex items-center justify-center">
        {/* Center the logo */}
        <img src={BigLogo} alt="nAI" className="w-auto h-[50px] lg:h-[100px] xl:h-[150px]" />
        <h3 className="fixed bottom-5 font-bold text-lg text-gray-700">
          Powered By <span className="text-black">Navatech</span>
        </h3>
      </Box>
      {/* Right side */}
      <img src={BigLogo} alt="nAI" className="fixed md:hidden w-auto h-[40px] top-4" />
      <div className="w-full md:w-1/2 bg-white flex items-center justify-center">
        <div className="w-[450px] max-w-[90%]">{children}</div>
      </div>
      <h3 className="fixed md:hidden bottom-5 font-bold text-md text-gray-700">
        Powered By <span className="text-black">Navatech</span>
      </h3>
    </div>
  )
}

export default LRFLayout
